import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MaintenanceStrategyPlannedMaintenance } from '../../../../viewmodels/maintenance-strategies/maintenance-strategy-planned-maintenance';
import { MaintenanceStrategyPlannedMaintenanceService } from '../maintenance-strategy-planned-maintenance.service';

@Component({
  selector: 'hb-maintenance-strategy-planned-maintenance-dialog',
  templateUrl: './maintenance-strategy-planned-maintenance-dialog.component.html',
  styleUrls: ['./maintenance-strategy-planned-maintenance-dialog.component.scss'],
})
export class MaintenanceStrategyPlannedMaintenanceDialogComponent implements OnInit, OnDestroy {
  public selectedPlannedMaintenance: MaintenanceStrategyPlannedMaintenance[] = [];
  public availablePlannedMaintenance: MaintenanceStrategyPlannedMaintenance[] = [];

  private unsubscribe: Subject<boolean> = new Subject();

  constructor(
    public bsModalRef: BsModalRef,
    private plannedMaintenanceService: MaintenanceStrategyPlannedMaintenanceService
  ) { }

  public ngOnInit(): void {
    this.plannedMaintenanceService.availablePlannedMaintenance.pipe(takeUntil(this.unsubscribe)).subscribe(availablePlannedMaintenance => {
      this.availablePlannedMaintenance = availablePlannedMaintenance;
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  public submitClick(): void | null {
    if (this.selectedPlannedMaintenance.length === 0) { return null; }

    this.plannedMaintenanceService.acceptAddedMaintenance(this.selectedPlannedMaintenance);
  }

  public onSelectionChanged(selectedPlannedMaintenance: MaintenanceStrategyPlannedMaintenance[]): void {
    this.selectedPlannedMaintenance = selectedPlannedMaintenance;
  }
}
